// src/lib/layouts/clampFillerSpeed.ts
export const FILLER_SPEED_MIN = 1;
export const FILLER_SPEED_MAX = 4;
export const FILLER_SPEED_DEFAULT = 1;

/** Clamp a filler playback speed into [1, 4]; junk falls back to 1x. */
export function clampFillerSpeed(value: unknown): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return FILLER_SPEED_DEFAULT;
  return Math.min(FILLER_SPEED_MAX, Math.max(FILLER_SPEED_MIN, n));
}
